import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type LinkLang = "es" | "us";

export function useLinkLang(): LinkLang {
  const { i18n } = useTranslation();

  return useMemo(() => {
    // idioma ativo do i18n (pt, es, en, pt-BR, en-US, etc.)
    const rawLang = (i18n.resolvedLanguage || i18n.language || "es").toLowerCase();

    // pega só o prefixo (pt-br -> pt)
    const langPrefix = rawLang.split("-")[0];

    // mapeia para idioma aceito nos links
    return langPrefix === "en" ? "us" : "es";
  }, [i18n.language, i18n.resolvedLanguage]);
}